import useLocales from 'hooks/useLocales';
import { useParams } from 'react-router';
import { RoutingServiceDashboard } from 'services/routing/RoutingService';
import { PATH_PARAM_DASHBOARD } from 'services/routing/PATH_PARAM';
import { useMemo } from 'react';
import { useSelector } from 'storage';
import { MODEL_PERMISSION } from 'configs/permissions/modelPermissions';

export default function useModelsDirectoryTabs() {
  const { permissions } = useSelector((state) => state.auth);
  const { translate } = useLocales();
  const params = useParams();
  return useMemo(() => {
    const tabs: TabData[] = [];
    if (permissions.can(MODEL_PERMISSION.CAN_READ_ENTERPRISE_USER_LIST)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.employees,
        href: RoutingServiceDashboard.modelsDirectory.employee.getListPath(params),
        label: translate('pages.enterprise.tabs.employees'),
      });
    }
    if (permissions.can(MODEL_PERMISSION.CAN_READ_ENTERPRISE_TECHNICIAN_LIST)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.technicians,
        href: RoutingServiceDashboard.modelsDirectory.technician.getListPath(params),
        label: translate('pages.enterprise.tabs.technicians'),
      });
    }
    if (permissions.can(MODEL_PERMISSION.CAN_READ_ENTERPRISE_TECHNICIAN_TEAM_LIST)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.technicianTeams,
        href: RoutingServiceDashboard.modelsDirectory.technicianTeam.getListPath(params),
        label: translate('pages.enterprise.tabs.technicianTeams'),
      });
    }
    if (permissions.can(MODEL_PERMISSION.CAN_READ_ENTERPRISE_DEPARTMENT_LIST)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.departments,
        href: RoutingServiceDashboard.modelsDirectory.department.getListPath(params),
        label: translate('pages.enterprise.tabs.departments'),
      });
    }
    if (permissions.can(MODEL_PERMISSION.CAN_READ_SHOP_LIST)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.shops,
        href: RoutingServiceDashboard.modelsDirectory.shop.getListPath(params),
        label: translate('pages.enterprise.tabs.shops'),
      });
    }

    if (permissions.can(MODEL_PERMISSION.CAN_READ_DOCUMENT_TEMPLATE)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.documentTemplates,
        href: RoutingServiceDashboard.modelsDirectory.documentTemplate.getListPath(params),
        label: translate('pages.enterprise.tabs.documentTemplates'),
      });
    }

    if (permissions.can(MODEL_PERMISSION.CAN_READ_ENTERPRISE_SERVICE_GROUP_LIST)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.services,
        href: RoutingServiceDashboard.modelsDirectory.service.enterprise.getListPath(params),
        label: translate('pages.enterprise.tabs.services'),
      });
    }
    if (permissions.can(MODEL_PERMISSION.CAN_READ_SERVICE_PACKAGE)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.servicePackages,
        href: RoutingServiceDashboard.modelsDirectory.servicePackage.getListPath(params),
        label: translate('pages.enterprise.tabs.servicePackages'),
      });
    }
    if (permissions.can(MODEL_PERMISSION.CAN_READ_BRAND_LIST)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.brands,
        href: RoutingServiceDashboard.modelsDirectory.brand.getListPath(params),
        label: translate('pages.enterprise.tabs.brands'),
      });
    }
    if (permissions.can(MODEL_PERMISSION.CAN_READ_ENTERPRISE_LEGAL_ENTITY_LIST)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.legalEntities,
        href: RoutingServiceDashboard.modelsDirectory.legalEntity.getListPath(params),
        label: translate('pages.enterprise.tabs.legalEntities'),
      });
    }

    if (permissions.can(MODEL_PERMISSION.CAN_READ_ENTERPRISE_REGION_LIST)) {
      tabs.push({
        value: PATH_PARAM_DASHBOARD.modelsDirectory.regions,
        href: RoutingServiceDashboard.modelsDirectory.region.getListPath(params),
        label: translate('pages.enterprise.tabs.regions'),
      });
    }

    return tabs;
  }, []);
}
